<app-image
  [sources]="getFlagImageSources(languageCode())"
  [defaultSrc]="getFlagImagePath(languageCode())"
  [borderRadius]="ImageBorderRadiusEnum.ROUND"
></app-image>
